import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { User, Users, CalendarCheck, Shield } from 'lucide-react';
import { Modal } from '../components/Modal';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
type BookingType = 'individu' | 'kelompok' | null;
export function Konseling() {
  const [bookingType, setBookingType] = useState<BookingType>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleBookingSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setBookingType(null);
      alert('Jadwal konseling berhasil diajukan. Guru BK akan segera mengkonfirmasi. Kerahasiaan Anda terjamin.');
    }, 1000);
  };
  const renderBookingForm = () => {
    if (!bookingType) return null;
    const title = bookingType === 'individu' ? 'Jadwalkan Konseling Individu' : 'Jadwalkan Konseling Kelompok';
    return <Modal isOpen={!!bookingType} onClose={() => setBookingType(null)} title={title} data-id="element-328">
        <form onSubmit={handleBookingSubmit} className="space-y-4" data-id="element-329">
          <Input label="Nama Lengkap" required placeholder="Masukkan nama" data-id="element-330" />
          <Input label="Kelas" required placeholder="Contoh: X IPA 1" data-id="element-331" />
          <Input label="No. HP / WhatsApp" type="tel" required placeholder="08..." data-id="element-332" />
          <Input label="Keluhan / Masalah yang dihadapi" as="textarea" required placeholder="Ceritakan secara singkat apa yang sedang kamu alami..." data-id="element-333" />
          <Input label="Jadwal yang dipilih" type="datetime-local" required data-id="element-334" />

          <div className="bg-pastel-blue-light/50 p-4 rounded-xl flex items-start gap-3 mt-2" data-id="element-335">
            <Shield className="text-blue-600 w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-336" />
            <p className="text-xs text-blue-800" data-id="element-337">
              <strong data-id="element-338">Asas Kerahasiaan:</strong> Segala informasi yang kamu
              sampaikan dalam sesi konseling akan dijaga kerahasiaannya oleh
              Guru BK sesuai dengan kode etik profesi.
            </p>
          </div>

          <div className="pt-4" data-id="element-339">
            <Button type="submit" fullWidth isLoading={isSubmitting} data-id="element-340">
              Ajukan Jadwal Konseling
            </Button>
          </div>
        </form>
      </Modal>;
  };
  return <div className="min-h-screen bg-white py-12" data-id="element-341">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-342">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-343">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} data-id="element-344">
            <h1 className="text-4xl font-bold text-dark mb-6" data-id="element-345">
              Layanan Konseling
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-346">
              Konseling adalah proses pemberian bantuan yang dilakukan melalui
              wawancara oleh seorang ahli (konselor) kepada individu yang sedang
              mengalami sesuatu masalah (klien) yang bermuara pada teratasinya
              masalah yang dihadapi klien.
            </p>
            <div className="inline-flex items-center gap-2 bg-pastel-pink-light text-pink-800 px-4 py-2 rounded-full text-sm font-medium" data-id="element-347">
              <Shield size={16} data-id="element-348" />
              Kerahasiaan Terjamin 100%
            </div>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-349">
          {/* Konseling Individu */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-3xl p-8 border border-pastel-grey shadow-sm hover:shadow-apple transition-all duration-300 flex flex-col" data-id="element-350">
            <div className="w-16 h-16 rounded-2xl bg-pastel-blue-light flex items-center justify-center mb-6" data-id="element-351">
              <User className="text-blue-600 w-8 h-8" data-id="element-352" />
            </div>
            <h2 className="text-2xl font-bold text-dark mb-4" data-id="element-353">
              Konseling Individu
            </h2>
            <p className="text-gray-600 mb-8 flex-grow leading-relaxed" data-id="element-354">
              Layanan konseling yang diselenggarakan oleh Guru BK terhadap
              seorang siswa dalam rangka pengentasan masalah pribadi yang
              dialaminya. Sesi ini bersifat sangat privat dan rahasia.
            </p>
            <Button size="lg" fullWidth onClick={() => setBookingType('individu')} data-id="element-355">
              <CalendarCheck size={20} className="mr-2" data-id="element-356" /> Jadwalkan Sesi
            </Button>
          </motion.div>

          {/* Konseling Kelompok */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-3xl p-8 border border-pastel-grey shadow-sm hover:shadow-apple transition-all duration-300 flex flex-col" data-id="element-357">
            <div className="w-16 h-16 rounded-2xl bg-pastel-pink-light flex items-center justify-center mb-6" data-id="element-358">
              <Users className="text-pink-600 w-8 h-8" data-id="element-359" />
            </div>
            <h2 className="text-2xl font-bold text-dark mb-4" data-id="element-360">
              Konseling Kelompok
            </h2>
            <p className="text-gray-600 mb-8 flex-grow leading-relaxed" data-id="element-361">
              Layanan konseling yang diselenggarakan oleh Guru BK terhadap
              sekelompok siswa yang memiliki masalah serupa. Memanfaatkan
              dinamika kelompok untuk saling membantu memecahkan masalah.
            </p>
            <Button size="lg" variant="outline" fullWidth onClick={() => setBookingType('kelompok')} data-id="element-362">
              <CalendarCheck size={20} className="mr-2" data-id="element-363" /> Jadwalkan Sesi
            </Button>
          </motion.div>
        </div>

        {renderBookingForm()}
      </div>
    </div>;
}